export class ProjectRole
{
    public roleId: string = '';
    public projectId: string = '';
    public name: string = '';
    public memberGroupId: string = '';

    // public abstract async getProjectRoles(): Promise<ProjectRole[]>;
    public static fromAutodeskJSON(json: any): ProjectRole
    {
        let role = new ProjectRole();
        role.name = json.name;
        role.roleId = json.id;
        role.projectId = json.project_id;
        role.memberGroupId = json.member_group_id;
        return role;
    }
}
